export class BirthdayStar {
  guestName?: string;
  age?: number;
  gender?: string;
}
